import { IpaginatedSeccionits, ISeccionitsItem } from '../models'

export enum SeccionitsActionTypes {
  SEARCH_SECCIONITS = 'seccionits/search',
  SEARCHING_SECCIONITS = 'seccionits/searching',
  FOUND_SECCIONITS = 'seccionits/found',
  SEARCHING_SECCIONITS_FAILED = 'seccionits/searching_failed',

  LOAD_SECCIONITS = 'seccionits/load',
  LOADING_SECCIONITS = 'seccionits/loading',
  LOADED_SECCIONITS = 'seccionits/loaded',
  LOADING_SECCIONITS_FAILED = 'seccionits/loading_failed',

  ADD_SECCIONITS = 'seccionits/add',
  ADDING_SECCIONITS = 'seccionits/adding',
  ADDED_SECCIONITS = 'seccionits/added',
  ADDING_SECCIONITS_FAILED = 'seccionits/adding_failed',

  REMOVE_SECCIONIT = 'seccionits/remove',
  REMOVING_SECCIONIT = 'seccionits/removing',
  REMOVED_SECCIONIT = 'seccionits/removed',
  REMOVING_SECCIONIT_FAILED = 'seccionits/removing_failed',

  SOFT_REMOVE_SECCIONITS = 'seccionits/soft_remove',
  SOFT_REMOVING_SECCIONITS = 'seccionits/soft_removing',
  SOFT_REMOVED_SECCIONITS = 'seccionits/soft_removed',
  SOFT_REMOVING_SECCIONITS_FAILED = 'seccionits/soft_removing_failed',

  EDIT_SECCIONITS = 'seccionits/edit',
  EDITING_SECCIONITS = 'seccionits/editing',
  EDITED_SECCIONITS = 'seccionits/edited',
  EDITING_SECCIONITS_FAILED = 'seccionits/editing_failed',

  VIEW_SECCIONITS = 'seccionits/view',
  VIEWING_SECCIONITS = 'seccionits/viewing',
  VIEWED_SECCIONITS = 'seccionits/viewed',
  VIEWING_SECCIONITS_FAILED = 'seccionits/viewing_failed',
}

export function searchSeccionits(searchOptions: TSearchOptions | string, keep?: boolean): ISearchSeccionitsAction {
  return {
    type: SeccionitsActionTypes.SEARCH_SECCIONITS,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingSeccionits(): ISearchingSeccionitsAction {
  return {
    type: SeccionitsActionTypes.SEARCHING_SECCIONITS,
  }
}

export function foundSeccionits(seccionits: IpaginatedSeccionits, keep?: boolean): IFoundSeccionitsAction {
  return {
    type: SeccionitsActionTypes.FOUND_SECCIONITS,
    keep: keep,
    payload: {
      seccionits,
    },
  }
}

export function searchingSeccionitsFailed(): ISearchingSeccionitsFailedAction {
  return {
    type: SeccionitsActionTypes.SEARCHING_SECCIONITS_FAILED,
  }
}

export function loadSeccionits(loadOptions: TSearchOptions): ILoadSeccionitsAction {
  return {
    type: SeccionitsActionTypes.LOAD_SECCIONITS,
    loadOptions: loadOptions,
  }
}

export function loadingSeccionits(): ILoadingSeccionitsAction {
  return {
    type: SeccionitsActionTypes.LOADING_SECCIONITS,
  }
}

export function loadedSeccionits(seccionits: IpaginatedSeccionits): ILoadedSeccionitsAction {
  return {
    type: SeccionitsActionTypes.LOADED_SECCIONITS,
    payload: {
      seccionits,
    },
  }
}

export function loadingSeccionitsFailed(): ILoadingSeccionitsFailedAction {
  return {
    type: SeccionitsActionTypes.LOADING_SECCIONITS_FAILED,
  }
}

export function addSeccionits(seccionit: ISeccionitsItem): IAddSeccionitsAction {
  return {
    type: SeccionitsActionTypes.ADD_SECCIONITS,
    payload: seccionit,
  }
}

export function addingSeccionits(): IAddingSeccionitsAction {
  return {
    type: SeccionitsActionTypes.ADDING_SECCIONITS,
  }
}

export function addedSeccionits(seccionits: IpaginatedSeccionits): IAddedSeccionitsAction {
  return {
    type: SeccionitsActionTypes.ADDED_SECCIONITS,
    payload: {
      seccionits,
    },
  }
}

export function addingSeccionitsFailed(errData: { data: { message: string; field?: string }; status: number }): IAddingSeccionitsFailedAction {
  return {
    type: SeccionitsActionTypes.ADDING_SECCIONITS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeSeccionit(seccionit: ISeccionitsItem): IRemoveSeccionitAction {
  return {
    type: SeccionitsActionTypes.REMOVE_SECCIONIT,
    payload: seccionit,
  }
}

export function removingSeccionit(): IRemovingSeccionitAction {
  return {
    type: SeccionitsActionTypes.REMOVING_SECCIONIT,
  }
}

export function removedSeccionit(): IRemovedSeccionitAction {
  return {
    type: SeccionitsActionTypes.REMOVED_SECCIONIT,
  }
}

export function removingSeccionitFailed(): IRemovingSeccionitFailedAction {
  return {
    type: SeccionitsActionTypes.REMOVING_SECCIONIT_FAILED,
  }
}

export function softRemoveSeccionits(seccionit: ISeccionitsItem): ISoftRemoveSeccionitsAction {
  return {
    type: SeccionitsActionTypes.SOFT_REMOVE_SECCIONITS,
    payload: seccionit,
  }
}

export function softRemovingSeccionits(): ISoftRemovingSeccionitsAction {
  return {
    type: SeccionitsActionTypes.SOFT_REMOVING_SECCIONITS,
  }
}

export function softRemovedSeccionits(seccionit: ISeccionitsItem): ISoftRemovedSeccionitsAction {
  return {
    type: SeccionitsActionTypes.SOFT_REMOVED_SECCIONITS,
    payload: seccionit,
  }
}

export function softRemovingSeccionitsFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingSeccionitsFailedAction {
  return {
    type: SeccionitsActionTypes.SOFT_REMOVING_SECCIONITS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editSeccionits(seccionit: ISeccionitsItem): IEditSeccionitsAction {
  return {
    type: SeccionitsActionTypes.EDIT_SECCIONITS,
    payload: seccionit,
  }
}

export function editingSeccionits(): IEditingSeccionitsAction {
  return {
    type: SeccionitsActionTypes.EDITING_SECCIONITS,
  }
}

export function editedSeccionits(seccionits: ISeccionitsItem): IEditedSeccionitsAction {
  return {
    type: SeccionitsActionTypes.EDITED_SECCIONITS,
    payload: seccionits,
  }
}

export function editingSeccionitsFailed(errData: { data: { message: string; field?: string }; status: number }): IEditingSeccionitsFailedAction {
  return {
    type: SeccionitsActionTypes.EDITING_SECCIONITS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewSeccionits(seccionit: ISeccionitsItem): IViewSeccionitsAction {
  return {
    type: SeccionitsActionTypes.VIEW_SECCIONITS,
    payload: seccionit,
  }
}

export function viewingSeccionits(): IViewingSeccionitsAction {
  return {
    type: SeccionitsActionTypes.VIEWING_SECCIONITS,
  }
}

export function viewedSeccionits(seccionits: ISeccionitsItem): IViewedSeccionitsAction {
  return {
    type: SeccionitsActionTypes.VIEWED_SECCIONITS,
    payload: seccionits,
  }
}

export function viewingSeccionitsFailed(): IViewingSeccionitsFailedAction {
  return {
    type: SeccionitsActionTypes.VIEWING_SECCIONITS_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchSeccionitsAction {
  type: SeccionitsActionTypes.SEARCH_SECCIONITS
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingSeccionitsAction {
  type: SeccionitsActionTypes.SEARCHING_SECCIONITS
}

export interface IFoundSeccionitsAction {
  type: SeccionitsActionTypes.FOUND_SECCIONITS
  keep?: boolean
  payload: {
    seccionits: IpaginatedSeccionits
  }
}

export interface ISearchingSeccionitsFailedAction {
  type: SeccionitsActionTypes.SEARCHING_SECCIONITS_FAILED
}

export interface ILoadSeccionitsAction {
  type: SeccionitsActionTypes.LOAD_SECCIONITS
  loadOptions: TSearchOptions
}

export interface ILoadingSeccionitsAction {
  type: SeccionitsActionTypes.LOADING_SECCIONITS
}

export interface ILoadedSeccionitsAction {
  type: SeccionitsActionTypes.LOADED_SECCIONITS
  payload: {
    seccionits: IpaginatedSeccionits
  }
}

export interface ILoadingSeccionitsFailedAction {
  type: SeccionitsActionTypes.LOADING_SECCIONITS_FAILED
}

export interface IAddSeccionitsAction {
  type: SeccionitsActionTypes.ADD_SECCIONITS
  payload: ISeccionitsItem
}

export interface IAddingSeccionitsAction {
  type: SeccionitsActionTypes.ADDING_SECCIONITS
}

export interface IAddedSeccionitsAction {
  type: SeccionitsActionTypes.ADDED_SECCIONITS
  payload: {
    seccionits: IpaginatedSeccionits
  }
}

export interface IAddingSeccionitsFailedAction {
  type: SeccionitsActionTypes.ADDING_SECCIONITS_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveSeccionitAction {
  type: SeccionitsActionTypes.REMOVE_SECCIONIT
  payload: ISeccionitsItem
}

export interface IRemovingSeccionitAction {
  type: SeccionitsActionTypes.REMOVING_SECCIONIT
}

export interface IRemovedSeccionitAction {
  type: SeccionitsActionTypes.REMOVED_SECCIONIT
}

export interface IRemovingSeccionitFailedAction {
  type: SeccionitsActionTypes.REMOVING_SECCIONIT_FAILED
}

export interface ISoftRemoveSeccionitsAction {
  type: SeccionitsActionTypes.SOFT_REMOVE_SECCIONITS
  payload: ISeccionitsItem
}

export interface ISoftRemovingSeccionitsAction {
  type: SeccionitsActionTypes.SOFT_REMOVING_SECCIONITS
}

export interface ISoftRemovedSeccionitsAction {
  type: SeccionitsActionTypes.SOFT_REMOVED_SECCIONITS
  payload: ISeccionitsItem
}

export interface ISoftRemovingSeccionitsFailedAction {
  type: SeccionitsActionTypes.SOFT_REMOVING_SECCIONITS_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditSeccionitsAction {
  type: SeccionitsActionTypes.EDIT_SECCIONITS
  payload: ISeccionitsItem
}

export interface IEditingSeccionitsAction {
  type: SeccionitsActionTypes.EDITING_SECCIONITS
}

export interface IEditedSeccionitsAction {
  type: SeccionitsActionTypes.EDITED_SECCIONITS
  payload: ISeccionitsItem
}

export interface IEditingSeccionitsFailedAction {
  type: SeccionitsActionTypes.EDITING_SECCIONITS_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewSeccionitsAction {
  type: SeccionitsActionTypes.VIEW_SECCIONITS
  payload: ISeccionitsItem
}

export interface IViewingSeccionitsAction {
  type: SeccionitsActionTypes.VIEWING_SECCIONITS
}

export interface IViewedSeccionitsAction {
  type: SeccionitsActionTypes.VIEWED_SECCIONITS
  payload: ISeccionitsItem
}

export interface IViewingSeccionitsFailedAction {
  type: SeccionitsActionTypes.VIEWING_SECCIONITS_FAILED
}

export type SeccionitsAction =
  | ISearchSeccionitsAction
  | ISearchingSeccionitsAction
  | IFoundSeccionitsAction
  | ISearchingSeccionitsFailedAction
  | ILoadSeccionitsAction
  | ILoadingSeccionitsAction
  | ILoadedSeccionitsAction
  | ILoadingSeccionitsFailedAction
  | IAddSeccionitsAction
  | IAddingSeccionitsAction
  | IAddedSeccionitsAction
  | IAddingSeccionitsFailedAction
  | IRemoveSeccionitAction
  | IRemovingSeccionitAction
  | IRemovedSeccionitAction
  | IRemovingSeccionitFailedAction
  | ISoftRemoveSeccionitsAction
  | ISoftRemovingSeccionitsAction
  | ISoftRemovedSeccionitsAction
  | ISoftRemovingSeccionitsFailedAction
  | IEditSeccionitsAction
  | IEditingSeccionitsAction
  | IEditedSeccionitsAction
  | IEditingSeccionitsFailedAction
  | IViewSeccionitsAction
  | IViewingSeccionitsAction
  | IViewedSeccionitsAction
  | IViewingSeccionitsFailedAction
